import { TextArea, Modal, PrimaryButton, PrimaryCardButton } from '@cb/apricot-react';
import { Grid } from '@mui/material';
import { ChangeEvent, FC, useEffect, useState } from 'react';

import { useToasts } from 'src/hooks';
import { Checkbox } from 'src/components';
import { ISummary } from 'src/types';
import { useAuth } from 'src/contexts';
import { statusUpdate } from '../../../services/schoolRequest';
import { CircularProgress } from '@mui/material';

export interface IDeniedSubmitForm {
  statusComments: string;
  appealEligible: boolean;
}

export interface DeniedModalProps {
  isOpen?: boolean;
  request: ISummary | null;
  onClose: VoidFunction;
  onComplete: (request: ISummary) => void;
}

const DeniedModal: FC<DeniedModalProps> = ({ isOpen, request, onClose, onComplete }) => {

  const { lastName, firstName } = useAuth();
  const [loading, setLoading] = useState('');
  const [statusComments, setStatusComments] = useState('');
  const [appealEligible, setAppealEligible] = useState(true);
  const statusesToMoveToQC = ['processing', 'xpmDenied', 'appeal', 'international', 'testSecurity', 'deactivationApproval'];
  // ?? '' is nullish coalescing operator which gives default value (right side)if  left side is null or undefined
  const nextStatus =  statusesToMoveToQC.includes(request?.processStatus ?? '' ) ? 'qcReadyRejected' : 'rejected';
  const submitLabel = nextStatus === 'qcReadyRejected' ? 'Ready for QC' : 'Confirm';

  const { render: renderToasts, toastErrorMessage, toastSuccessMessage } = useToasts();

  const handleChangeStatusComments = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setStatusComments(event.target.value);
  };

  const handleAppealEligible = (checked: boolean) => {
    setAppealEligible(checked);
    if (checked) {
      toastSuccessMessage(null);
    }
    if (!checked) {
      toastSuccessMessage(
        'Unchecking Appeal Eligible box locks form for submitter. Submitter is unable to update and resubmit.',
      );
    }
  };

  const handleSubmit = async () => {
    if (!statusComments) {
      toastErrorMessage('Incomplete data -- please enter comments for user');
    }
    else if (!request) {
      toastErrorMessage('Incomplete data -- please enter comments for user');
    }
    else {
      setLoading('Saving');
      toastErrorMessage(null);

      try {
        
        const updated = await statusUpdate(request.userId, request.categoryId, {
          user: lastName + ', ' + firstName,
          status: nextStatus,
          appealEligible: (request.requestType === 'create'  && request?.recordCategoryType !== 'di')? appealEligible : false,
          comment: statusComments
        });
        request.updateDate = updated.time;
        onComplete(request);
      } catch (error: any) {
        toastErrorMessage(error.message);
      }
      setLoading('');
    }
  };

  useEffect(() => {
    setStatusComments( request?.processStatusComments?.trim() || '');
    setAppealEligible(true);
    toastErrorMessage(null);
    toastSuccessMessage(null);
  }, [isOpen, toastErrorMessage, toastSuccessMessage]);

  return (
    // @ts-ignore
    <Modal
      title= {
        <div style={{fontSize: '22px', fontWeight: 'bold'}}>
          Denial Reasons
          <span style={{color: 'red'}}> To Submitter
          </span>
        </div>
        }
      actions={[
        <PrimaryButton key="submit" onClick={handleSubmit} disabled={loading ? true : false}>
          {submitLabel}
        </PrimaryButton>,
        <PrimaryCardButton key="close" onClick={onClose} disabled={loading ? true : false}>
          Close
        </PrimaryCardButton>,
      ]}
      closeButton={false}
      open={isOpen}
      onClose={onClose}
      withHeader>
      {renderToasts()}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextArea onChange={handleChangeStatusComments} value={statusComments} maxLength={5000} />
        </Grid>
        <Grid item xs={12}>
          { (request?.requestType === 'create'  && request?.recordCategoryType !== 'di')&&
            <Checkbox
              key="appeal-eligible"
              checked={appealEligible}
              label="Appeal Eligible"
              onChange={handleAppealEligible}
            />
          }
        </Grid>
      </Grid>

      {loading &&
        <div style={{ marginTop: '20px' }}>
          <Grid item xs={12}><CircularProgress /> <div style={{ display: 'inline-block', fontSize: '20px' }}>{loading}</div></Grid>
        </div>
      }
    </Modal>
  );
};
export default DeniedModal;
